import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import {URL} from '../../util/ambienteActions';
import {montarURLFiltro} from '../../util/filtros';

export const BUSCAR_TIPOS = '@cuponsActions/BUSCAR_TIPOS';
export const BUSCAR_CUPONS = '@cuponsActions/BUSCAR_CUPONS';
export const CRIAR_CUPOM = '@cuponsActions/CRIAR_CUPOM';
export const ALTERAR_CUPOM = '@cuponsActions/ALTERAR_CUPOM';
export const ATIVAR_CUPOM = '@cuponsActions/ATIVAR_CUPOM';
export const INATIVAR_CUPOM = '@cuponsActions/INATIVAR_CUPOM';
export const DETERMINAR_PAGINA_ATUAL_CUPONS = '@cuponsActions/DETERMINAR_PAGINA_ATUAL_CUPONS';
export const ALTERAR_NUMERO_REGISTROS_POR_PAGINA_CUPONS = '@cuponsActions/ALTERAR_NUMERO_REGISTROS_POR_PAGINA_CUPONS';
export const BUSCAR_TIPOS_ORIGENS_REQUISICAO_CUPOM = '@cuponsActions/BUSCAR_TIPOS_ORIGENS_REQUISICAO_CUPOM'


export function buscarOrigensRequisicaoCupom () {
  const url = `${URL}/cupom/origens-requisicao`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_TIPOS_ORIGENS_REQUISICAO_CUPOM,        
        payload: {
          origensRequisicaoCupom: response.data,
        }

      })
  );
}

export function buscarTipos () {
  const url = `${URL}/cupom/tipos`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_TIPOS,
      payload: {
        tipos: response.data,
      }
    })
  )
}

export function buscarCupons (pagina, registrosPorPagina, filtros) {
    const urlFiltros = montarURLFiltro(filtros, pagina, registrosPorPagina);
  const url = `${URL}/cupom/${urlFiltros}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_CUPONS,
      payload: response.data
    })
  )
}


export function cadastrarCupom (comandoCupom) {
  return dispatch => axios.post(`${URL}/cupom/cadastrar`, comandoCupom, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: CRIAR_CUPOM,
      payload: response.data
    })
  )
}

export function alterarCupom (comandoCupom) {
  return dispatch => axios.post(`${URL}/cupom/atualizar`, comandoCupom, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: ALTERAR_CUPOM,
      payload: response.data
    })
  )
}

export function excluirCupom (idCupom) {
  return dispatch => axios.get(`${URL}/cupom/${idCupom}/excluir`, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: ALTERAR_CUPOM,
      payload: response.data
    })
  )
}

export function ativarCupom (idCupom) {
  return dispatch => axios.post(`${URL}/cupom/${idCupom}/ativar`, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: ATIVAR_CUPOM,
      payload: response.data
    })
  )
}

export function inativarCupom (idCupom) {
  return dispatch => axios.post(`${URL}/cupom/${idCupom}/inativar`, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: INATIVAR_CUPOM,
      payload: response.data
    })
  )
}

export function determinarPaginaAtualCupons (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_CUPONS,
    payload: paginaAtual
  }
}

export function alterarRegistrosPorPaginaCupons (valor) {
  return {
    type: ALTERAR_NUMERO_REGISTROS_POR_PAGINA_CUPONS,
    payload: valor
  }
}


